import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AppErrorBoundary } from '@/components/AppErrorBoundary';
import { RequireAdmin } from '@/components/RequireAdmin';
import { RootLayout } from '@/components/layout/RootLayout';
import { AdminDetailPage } from '@/features/admin/AdminDetailPage';
import { AdminListPage } from '@/features/admin/AdminListPage';
import { RequireApplicant } from '@/features/applicant/RequireApplicant';
import { SignupPage } from '@/features/applicant/SignupPage';
import { VerifyPage } from '@/features/applicant/VerifyPage';
import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage';
import { LoginPage } from '@/features/auth/LoginPage';
import { ResetPasswordPage } from '@/features/auth/ResetPasswordPage';
import { RegistrationWizard } from '@/features/registration/RegistrationWizard';
import { ThankYouPage } from '@/features/registration/ThankYouPage';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <AppErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'forgot-password', element: <ForgotPasswordPage /> },
      { path: 'reset-password', element: <ResetPasswordPage /> },
      { path: 'apply/signup', element: <SignupPage /> },
      { path: 'apply/verify', element: <VerifyPage /> },
      {
        element: <RequireApplicant />,
        children: [
          { path: 'register', element: <RegistrationWizard /> },
          { path: 'register/thank-you', element: <ThankYouPage /> },
        ],
      },
      {
        path: 'admin',
        element: <RequireAdmin />,
        children: [
          { index: true, element: <Navigate to="/admin/submissions" replace /> },
          { path: 'submissions', element: <AdminListPage /> },
          { path: 'submissions/:id', element: <AdminDetailPage /> },
        ],
      },
    ],
  },
]);
